import React from 'react';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "../mychart/MyChartContainer";
import { MyChartHeading } from "../ecosystem/mybswh";

const CareCompanion = ({ match }) => {
    const { proxyName } = Tools.getProxyName();
    const heading = <MyChartHeading heading="Care Companion" proxyName={proxyName} />

    return (
        <MyChartContainer mode="todo" title="Care Companion" heading={heading} />
    );
}

export default CareCompanion;